/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { SearchImagesParams } from '../_model/searchImagesParams';
import type { SuccessBodyImageSearchRes } from '../_model/successBodyImageSearchRes';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 이미지 검색 (provider 통합·정규화 응답, 차단 검색어는 빈 결과)
 */
export const searchImages = (
  params: SearchImagesParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyImageSearchRes>(
    { url: `/image-search`, method: 'GET', params, signal },
    options,
  );
};

export const getSearchImagesQueryKey = (params: SearchImagesParams) => {
  return [`/image-search`, ...(params ? [params] : [])] as const;
};

export const getSearchImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchImages>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchImagesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchImages>>> = ({
    signal,
  }) => searchImages(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchImages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchImages>>
>;
export type SearchImagesQueryError = ErrorType<unknown>;

export function useSearchImages<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchImages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchImages>>,
          TError,
          Awaited<ReturnType<typeof searchImages>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchImages<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchImages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchImages>>,
          TError,
          Awaited<ReturnType<typeof searchImages>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchImages<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchImages>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 이미지 검색 (provider 통합·정규화 응답, 차단 검색어는 빈 결과)
 */

export function useSearchImages<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchImages>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchImagesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSearchImagesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchImagesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchImages>>> = ({
    signal,
  }) => searchImages(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof searchImages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchImagesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchImages>>
>;
export type SearchImagesSuspenseQueryError = ErrorType<unknown>;

export function useSearchImagesSuspense<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchImagesSuspense<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchImagesSuspense<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 이미지 검색 (provider 통합·정규화 응답, 차단 검색어는 빈 결과)
 */

export function useSearchImagesSuspense<
  TData = Awaited<ReturnType<typeof searchImages>>,
  TError = ErrorType<unknown>,
>(
  params: SearchImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getSearchImagesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
